'use strict';

angular.module('licensure.services')
    .factory('FBConditions', ['$http', '$q', function ($http, $q) {
        var get = function (args) {
            var d = $q.defer();

            $http.get(apiLocation + '/api/fbconditions/', {
                params: args
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                    d.resolve(null);
                });

            return d.promise;
        }

        return {
            get: get,

            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/fbconditions/' + id, {
                    params: {
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },

            save: function (condition) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/fbconditions/';
                if (!isUndefined(condition.id)) {
                    method = 'PUT';
                    url += condition.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        condition: condition
                    }
                }).then(function (response) {
                    d.resolve(response.data);
                }).catch(function (response) {
                    // handle error
                    d.resolve(null);
                });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/fbconditions/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;